module.exports = __webpack_public_path__ + "img/25.5b2a3e29.jpeg";